import { usePhanHeNoiTruContext } from "../../../PhanHeNoiTruContext";
import LichSuPhieuDieuTriComponent from "../../../../component/lich-su-phieu-dieu-tri/LichSuPhieuDieuTri";

const LichSuPhieuDieuTri = () => {
  const { benhNhanHanhChinh } = usePhanHeNoiTruContext();

  return (
    <LichSuPhieuDieuTriComponent patientId={benhNhanHanhChinh?.patientId} />
  );
};

export default LichSuPhieuDieuTri;
